module.exports = __webpack_public_path__ + "img/card2.54f0597.svg";